module.exports = __webpack_public_path__ + "img/3f_r_pepper.910850ec.png";